// @flow
import * as React from 'react';
import {InlineLink} from 'sail/InlineLink';

type ErrorProps = {
  errorMessage: ?string,
  errorMessageCode: ?string,
  event: ?string,
  dashboardUrl: string,
};

// Eventually, we want to update this error component to handle
// all error messages.
const CheckerError = (props: ErrorProps) => {
  const {dashboardUrl, errorMessage, errorMessageCode, event} = props;

  switch (errorMessageCode) {
    case 'integration_checker_no_dispute_created_webhook_found':
      return (
        <>
          No webhook that handles the <code>charge.dispute.created</code> event
          was found. Configure a corresponding webhook endpoint in the{' '}
          {event ? (
            <InlineLink
              href={`${dashboardUrl}/test/webhooks`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Dashboard.
            </InlineLink>
          ) : null}
        </>
      );
    case 'integration_checker_no_payment_intent_failed_webhook_found':
      return (
        <>
          No webhook that handles the <code>payment_intent.payment_failed</code>{' '}
          event was found. Configure a corresponding webhook endpoint in the{' '}
          <InlineLink
            href={`${dashboardUrl}/test/webhooks`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Dashboard.
          </InlineLink>
        </>
      );
    case 'integration_checker_no_payment_intent_succeeded_webhook_found':
      return (
        <>
          No webhook that handles the <code>payment_intent.succeeded</code>{' '}
          event was found. Configure a corresponding webhook endpoint in the{' '}
          <InlineLink
            href={`${dashboardUrl}/test/webhooks`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Dashboard.
          </InlineLink>
        </>
      );
    case 'integration_checker_dispute_created_event_not_handled':
      return (
        <>
          A webhook subscribed to the <code>charge.dispute.created</code> event{' '}
          did not successfully respond.{' '}
          {event ? (
            <InlineLink
              href={`${dashboardUrl}/test/events/${event}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              View event.
            </InlineLink>
          ) : null}
        </>
      );
    case 'integration_checker_payment_intent_failed_event_not_handled':
      return (
        <>
          A webhook subscribed to <code>payment_intent.payment_failed</code> did
          not successfully respond to the event.{' '}
          {event ? (
            <InlineLink
              href={`${dashboardUrl}/test/events/${event}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              View event.
            </InlineLink>
          ) : null}
        </>
      );
    case 'integration_checker_payment_intent_succeeded_event_not_handled':
      return (
        <>
          A webhook subscribed to <code>payment_intent.succeeded</code> did not
          successfully respond to the event.{' '}
          {event ? (
            <InlineLink
              href={`${dashboardUrl}/test/events/${event}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              View event.
            </InlineLink>
          ) : null}
        </>
      );
    case 'integration_checker_no_setup_future_usage':
      return (
        <>
          Set <code>setup_future_usage</code> to <code>off_session</code> to
          save the SEPA Debit account for reuse.{' '}
        </>
      );
    case 'integration_checkers_event_still_pending':
    case 'integration_checkers_webhook_still_pending':
      return (
        <>
          The webhook event has not yet been sent. Run this test again in a few
          seconds.
        </>
      );
    default:
      return <>{errorMessage}</>;
  }
};

export default CheckerError;
